import { useEffect, useState } from 'react';
import { useStore } from './store.js';

/** サーバー時刻を rAF で更新し続けるフック（描画中のみ有効化する） */
export function useServerNow(active: boolean, fps = 60, localClock = false): number {
  const serverOffset = useStore((s) => s.offset);
  const offset = localClock ? 0 : serverOffset;
  const [now, setNow] = useState(() => Date.now() + offset);
  useEffect(() => {
    if (!active) {
      setNow(Date.now() + offset);
      return;
    }
    let raf = 0;
    let last = 0;
    const step = (t: number) => {
      if (t - last >= 1000 / fps) {
        last = t;
        setNow(Date.now() + offset);
      }
      raf = requestAnimationFrame(step);
    };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [active, offset, fps]);
  return now;
}

/** 秒単位のカウントダウン表示用 */
export function useCountdownSeconds(until: number | undefined, active = true): number {
  const now = useServerNow(active && until !== undefined, 10);
  if (until === undefined) return 0;
  return Math.max(0, Math.ceil((until - now) / 1000));
}
